import type { FighterInput, TickBundle } from '@archon3d/core';
import type { TickBuffer } from '../net/tickBuffer';

/** How the arena's controller takes part in a duel the server runs. */
export interface LockstepLink {
  /** The next bundle in order, or nothing while the server has not sent it yet. */
  take(): TickBundle | undefined;
  /** Bundles ready after the next one; a growing backlog means the client fell behind. */
  readonly available: number;
  /** The local fighter's input for a coming tick. */
  send(tick: number, input: FighterInput): void;
  /** The local fighter gives up; the server settles it in a coming bundle. */
  forfeit(): void;
}

export interface LockstepTransport {
  sendInput(tick: number, input: FighterInput): void;
  sendForfeit(): void;
}

export function createLockstepLink(buffer: TickBuffer, transport: LockstepTransport): LockstepLink {
  return {
    take: () => buffer.take(),
    get available() {
      return buffer.available;
    },
    send: (tick, input) => transport.sendInput(tick, input),
    forfeit: () => transport.sendForfeit(),
  };
}
